import { createElement } from 'react';
import { Cascader as OriginalCascader } from 'antd';
const Cascader = function Cascader({ ...otherProps }) {
    const _otherProps = otherProps || {};
    return (createElement(OriginalCascader, { placeholder: "Please select", ..._otherProps }));
};
export default Cascader;
